const getPipelinesUrls = require('../common/getPipelinesUrls');
var cookieHelper = require('../utilities/cookie');
const PIPELINES_URLS = getPipelinesUrls();

/**
 * Calls Geolocation-RedirectByGeolocation endpoint
 * Used to redirect to corresponding endpoint avoiding cache
 */
function redirectByGeolocation() {
    const mustValidateUserGeolocation = !cookieHelper.cookieExists(
        cookieHelper.constants.ADLOCALE_COOKIE_NAME
    );
    if (mustValidateUserGeolocation) {
        fetch(PIPELINES_URLS.redirectByGeolocation, {
            method: 'GET'
        }).then((response) => response.json())
            .then((json) => {
                if (json.redirectUrl) {
                    window.location = json.redirectUrl;
                }
            });
    }
}

module.exports = {
    redirectByGeolocation: redirectByGeolocation
};
